import React from 'react'
import { dateDiffDays } from '../../utils/parseStartDate'
import { formatDeadlineRelativeBadge } from '../DeadlineDropdown/deadlineDropdownUtils'
import { TaskDeadlineIcon } from '@/src/renderer/components/icons'
import './TaskDeadlineBadge.scss'
import type { TaskDeadlineBadgeProps } from './TaskDeadlineBadge.types'

export function TaskDeadlineBadge({ value, locale }: TaskDeadlineBadgeProps) {
  const now = new Date()
  const diff = dateDiffDays(value.date, now)

  const modifier = diff < 0
    ? 'task-deadline-badge--overdue'
    : diff === 0
    ? 'task-deadline-badge--today'
    : diff === 1
    ? 'task-deadline-badge--tomorrow'
    : ''

  return (
    <span className={`task-deadline-badge${modifier ? ` ${modifier}` : ''}`}>
      <TaskDeadlineIcon size={16} />
      <span className="task-deadline-badge__text">
        {formatDeadlineRelativeBadge(value, locale)}
      </span>
    </span>
  )
}
